import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=35b98143&scoped=true&"
var script = {}
import style0 from "./ContactView.vue?vue&type=style&index=0&id=35b98143&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b98143",
  null
  
)

export default component.exports